export default class ProductController {
	static currentProduct = null;

	static loadProduct(product) {
		this.currentProduct = product;
		console.log('loadProduct', product);
	}

	static selectSize(id) {
		console.log(id, STORESIZES);
		const x = STORESIZES[window.locale].find((s) => s.id === id);
		this.currentProduct.size = x;
		console.log(x);
	}

	static selectFrame(id) {
		console.log(id, STOREFRAMES);
		const x = STOREFRAMES[window.locale].find((s) => s.id === id);
		this.currentProduct.frame = x;
		console.log(x);
	}

	static updatePrice() {
		const sizePrice = window.locale === 'ua' ? this.currentProduct.size['price-uah'] : this.currentProduct.size.price;
		let framePrice = 0;
		console.log(this.currentProduct.size);
		if (Array.isArray(this.currentProduct.frame.price)) {
			const id = this.currentProduct.size.id;
			const frame = this.currentProduct.frame.price.find((f) => f.size === id);
			framePrice = window.locale === 'ua' ? frame['price-uah'] : frame.price;
		} else {
			console.log(this.currentProduct.frame);
			framePrice = window.locale === 'ua' ? this.currentProduct.frame['price-uah'] : this.currentProduct.frame.price
		}
		console.log('sizePrice', sizePrice, 'framePrice', framePrice);
		const total =
			sizePrice + framePrice; // it is a number, for ex 3600 which stands for $36.00 in price string
		let totalInUah = total; // for now, we assume 1:1 exchange rate
		// const totalInUah = total * 42;

		const priceText = `$${(total / 100).toFixed(2)}`;
		const priceTextUah = `${(totalInUah)} грн.`;

		this.currentProduct.price = window.locale === 'ua' ? totalInUah : total;
		this.currentProduct.pricestring = window.locale === 'ua' ? priceTextUah :  priceText;
	}

	static getProduct() {
		return this.currentProduct;
	}

	static getProductPrice() {
		return this.currentProduct.price;
	}

	static getProductPriceString() {
		return this.currentProduct.pricestring;
	}
}
